module.exports = __webpack_public_path__ + "static/media/hero_image.9cee681a.svg";